export const NEVER_SWITCH = ['/', '/login', '/reset_password_view']

export const isV2Path = p => p === '/v2' || p.startsWith('/v2/')
export const toV2Path = p => (isV2Path(p) ? p : '/v2' + p)
